import React from "react";
import { Helmet } from "react-helmet-async";

const SEO = ({
  title,
  description,
  keywords,
  url,
  image,
  type = "website",
  noindex = false,
}) => {
  const siteUrl = "https://chandelierluxe.co.za";
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  const imageUrl = image
    ? image.startsWith("http")
      ? image
      : `${siteUrl}${image}`
    : `${siteUrl}/assets/images/hero-chandelier.jpeg`;

  const titleTemplate = title
    ? `${title} | Chandelier Luxe`
    : "Chandelier Luxe | Luxury Crystal Chandeliers & Lighting Solutions";

  const metaDescription =
    description ||
    "Chandelier Luxe offers premium crystal chandeliers, installation, restoration, and maintenance services in Johannesburg, South Africa. 25+ years of excellence, 1000+ installations.";

  const metaKeywords =
    keywords ||
    "crystal chandeliers, luxury lighting, chandelier installation, chandelier restoration, crystal lighting Johannesburg, luxury chandeliers South Africa, custom chandeliers, Swarovski crystals, Asfour crystals, chandelier maintenance, chandelier repair";

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{titleTemplate}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      <link rel="canonical" href={fullUrl} />

      {/* Robots */}
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={titleTemplate} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:site_name" content="Chandelier Luxe" />
      <meta property="og:locale" content="en_ZA" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={titleTemplate} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={imageUrl} />

      {/* Additional SEO Meta Tags */}
      <meta name="author" content="Chandelier Luxe" />
      <meta name="geo.region" content="ZA-GP" />
      <meta name="geo.placename" content="Johannesburg" />
      <meta name="geo.position" content="-26.2041;28.0473" />
      <meta name="ICBM" content="-26.2041, 28.0473" />

      {/* Business Information */}
      <meta name="contact" content="info@chandelierluxe.co.za" />
      <meta name="phone" content="+27 84 422 9825" />
    </Helmet>
  );
};

export default SEO;

